import {createReducer} from "redux-act";
import {closeContextualPrompt, openContextualPrompt} from "modules/actions";

interface IPromptReducer {
	isContextualPromptOpen: boolean;
}

const initial: IPromptReducer = {
	isContextualPromptOpen: false,
};

export const prompt = createReducer({}, initial)
	.on(openContextualPrompt, (state) => ({
		...state,
		isContextualPromptOpen: true,
	}))
	.on(closeContextualPrompt, (state) => ({
		...state,
		isContextualPromptOpen: false,
	}));
